import React from 'react';
import {
  required,
  Create,
  SimpleForm,
  TranslatableInputs,
  TextInput,
  ReferenceInput,
  SelectInput
} from 'react-admin';

const validateCategoryTerroirs = required('Selecione uma categoria terrois!');
const validateName = [required('Digite o nome!')];

const SubCategoryTerroirsCreate = (props) => (
  <Create title="Nova Sub Categoria Terroirs" {...props}>
    <SimpleForm redirect="/sub-category-terroirs" >
      <ReferenceInput label="Categoria Terroirs" source="category_terroirs_id" fullWidth={true} reference="category-terroirs" validate={validateCategoryTerroirs}>
        <SelectInput optionText="name.pt_br" optionValue="id" />
      </ReferenceInput>
      <TranslatableInputs locales={['pt_br', 'en_us']} defaultLocale="pt_br">
        <TextInput source="name" label="Nome" fullWidth={true} validate={validateName} />
      </TranslatableInputs>
    </SimpleForm>
  </Create>
);

export default SubCategoryTerroirsCreate;
